import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import { useDispatch, useSelector } from "react-redux";
import {
  setForAll,
  setForFileManager,
  setIsMultiSelected,
  setIsSingleSelected,
  setMultiSelected,
  setShowFileUploader,
  setSingleSelected,
} from "../../../../redux/admin/fileManagerSlice";
import { useEffect, useState } from "react";
import ImageUploader from "../ImageUploader";
import { viewAllFiles } from "../../../../api/admin/filemanagerApi";
import { LazyLoadImage } from "react-lazy-load-image-component";
import AddButton from "../AddButton";
import CancelButton from "../CancelButton";

const FileUploadandSelect = () => {
  const [Tab, setTab] = useState(1);
  const { showFileUploader, multiSelected, forFileManager, forAll, allFiles } =
    useSelector((state) => state.file);
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(22);
  const [Pagination, setPagination] = useState("");
  const [IsMultiSelectEnable, setIsMultiSelectIsMultiSelectEnable] =
    useState(false);

  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setShowFileUploader(false));
    dispatch(setForFileManager(false));
    dispatch(setForAll(false));
    dispatch(setIsMultiSelected(false));
    dispatch(setMultiSelected([]));
  };
  useEffect(() => {
    viewAllFiles(dispatch, Page, Limit, setPagination, allFiles);
  }, [Page, Limit, dispatch]);
  const handleShowmore = (e) => {
    setPage((prev) => prev + 1);
  };
  const handleSelect = (item) => {
    if (IsMultiSelectEnable === false) {
      dispatch(setSingleSelected(item));
      dispatch(setShowFileUploader(false));
    } else {
      let updatedList = [];

      const exists = multiSelected.some((f) => f.id === item.id);

      if (exists) {
        updatedList = multiSelected.filter((f) => f.id !== item.id);
      } else {
        updatedList = [...multiSelected, item];
      }

      dispatch(setMultiSelected(updatedList)); // Now OK
    }
  };

  const handleMultiSelect = () => {
    setIsMultiSelectIsMultiSelectEnable(!IsMultiSelectEnable);
    dispatch(setIsSingleSelected(false));
    dispatch(setIsMultiSelected(true));
  };
  return (
    <>
      <Modal
        open={showFileUploader}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-desc"
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Sheet
          variant="outlined"
          className="w-[800px]"
          sx={{
            maxHeight: 800,
            borderRadius: "md",
            p: 3,
            boxShadow: "lg",
            overflow: "hidden",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <ModalClose variant="plain" sx={{ m: 1 }} />
          <Typography component="h2" level="h4" sx={{ mb: 1 }}>
            <div className="flex justify-start items-center gap-x-3">
              <p>Media Manager</p>
              {forAll && (
                <>
                  {IsMultiSelectEnable === false ? (
                    <AddButton
                      onClick={handleMultiSelect}
                      text="Select Multiple"
                      size="sm"
                    />
                  ) : (
                    <CancelButton
                      onClick={handleMultiSelect}
                      text="Cancel"
                      size="sm"
                    />
                  )}
                </>
              )}
            </div>
          </Typography>
          {forAll && (
            <div className="w-full h-auto pb-3">
              <div className="grid grid-cols-2 gap-x-3">
                <button
                  onClick={() => setTab(1)}
                  className={`px-4 py-2 bg-gray-100 text-sm  text-black/80 font-bold hover:bg-gray-200 duration-300 rounded-lg ${
                    Tab === 1 ? "bg-gray-200" : "bg-gray-100"
                  } `}
                >
                  All files
                </button>
                <button
                  onClick={() => setTab(2)}
                  className={`px-4 py-2 bg-gray-100 text-sm rounded-lg text-black/80 font-bold hover:bg-gray-200 duration-300 ${
                    Tab === 2 ? "bg-gray-200" : "bg-gray-100"
                  } `}
                >
                  Upload Files
                </button>
              </div>
            </div>
          )}
          {Tab === 1 && forAll && (
            <div className="w-full max-h-[600px] overflow-y-auto scrollbar-hide">
              <div className={`grid grid-cols-3 gap-5 auto-rows-auto`}>
                {allFiles.length > 0 ? (
                  <>
                    {allFiles.map((item, index) => {
                      const isImage = item.format?.startsWith("image");

                      return (
                        <>
                          <div
                            key={index}
                            className={`w-full h-[150px] p-3 bg-slate-100 rounded-lg cursor-pointer overflow-hidden grid-item`}
                          >
                            {isImage ? (
                              <LazyLoadImage
                                onClick={() => handleSelect(item)}
                                alt={item.fileName}
                                className="w-full h-full object-cover rounded-lg"
                                src={item.fileLink.small}
                                placeholderSrc={item.fileLink.small}
                                effect="blur"
                                width="100%"
                                height="100%"
                                visibleByDefault={true}
                              />
                            ) : (
                              <div className="w-full h-full flex items-center justify-center bg-white rounded-lg">
                                <a
                                  href={item.fileLink.original}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="text-sm font-medium text-blue-600 underline"
                                >
                                  {item.fileName}
                                </a>
                              </div>
                            )}
                          </div>
                        </>
                      );
                    })}
                    {Pagination.total !== allFiles.length && (
                      <button
                        onClick={handleShowmore}
                        className="w-full h-[150px] p-3 bg-blue-100 hover:bg-blue-200 font-bold uppercase duration-300 rounded-lg cursor-pointer"
                      >
                        {Pagination.total - allFiles.length} more
                      </button>
                    )}
                  </>
                ) : (
                  Array.from({ length: 12 }).map((_, index) => (
                    <div
                      key={index}
                      className="bg-slate-200 animate-pulse w-full h-[150px] rounded-lg"
                    ></div>
                  ))
                )}
              </div>
            </div>
          )}
          {forFileManager && <ImageUploader />}
          {Tab === 2 && forAll && <ImageUploader />}
        </Sheet>
      </Modal>
    </>
  );
};

export default FileUploadandSelect;
